import {AfterViewInit, Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CentreService} from "../../../../services/centre.service";
import {Centre} from "../../../../interfaces/Centres";
import {LogService} from "../../../../services/log.service";
import { MatSort } from '@angular/material/sort';
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {UserData} from "../../../../auth.service";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {DateRangeFormatService} from "../../../../utils/date-range-format.service";
import * as XLSX from 'xlsx';
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-education-impact-report-table',
  templateUrl: './education-impact-report-table.component.html',
  styleUrls: ['./education-impact-report-table.component.scss']
})
export class EducationImpactReportTableComponent implements OnInit, AfterViewInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  displayedColumns = ['sr', 'childName', 'from', 'to', 'createdAt', 'submitType','reportType','actions'];
  dataSource = new MatTableDataSource<any>(); // Use MatTableDataSource for pagination
  filteredDataSource = new MatTableDataSource<any>(); // Filtered data
  centres$!: Observable<Centre[]>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  // Filter criteria
  selectedCenterName: string | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  selectedSubmitType: any;
  SelectedCenters : any
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  userdata = JSON.parse(localStorage.getItem('userData')!)
  isExternal =  this.userdata.department == 'External User'
  reportType:string|undefined
  reportTypes=["Monthly","Quarter 1","Quarter 2","Quarter 3","Quarter 4","First Half","Second Half","2024-2025","2025-2026"]
  educationImpactReport = this.permissions.filter((x) => x.functionName == 'Education Report')[0]
  private originalData: any[] = [];
  constructor(private mFirestore: AngularFirestore,
              private mSnackbar: MatSnackBar,
              private mRouter: Router,
              private mLogService : LogService,
              private dateRangeFormatService: DateRangeFormatService,
              private centreService: CentreService,
              private financialYearService: FinancialYearService ) {}

  ngOnInit(): void {
    this.centres$ = this.centreService.getAllCentres()
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.fetchData();
  }
  fetchData(): void {
    this.mFirestore.collection(this.env.educationImpactReport, ref => ref.orderBy('createdAt', 'desc'))
      .valueChanges({ idField: 'id' })
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: any) => {
        this.originalData = data; // ← store original
        this.dataSource.data = data;
        this.filteredDataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }


  ngAfterViewInit() {
    this.filteredDataSource.paginator = this.paginator;
    this.filteredDataSource.sort = this.sort;
  }
  onCenterSelectionChange(event: any): void {
    this.selectedCenterName=event.value.centreCode;
  }

  filterData(event: any): void {
    if (this.startDate && this.endDate) {
      const normalized = this.dateRangeFormatService.normalizeRange(this.startDate, this.endDate);
      this.startDate = normalized.startDate;
      this.endDate = normalized.endDate;
    }

    let filteredData = [...this.originalData]; // ← always filter from original

    if (this.selectedCenterName && this.selectedCenterName !== 'All') {
      filteredData = filteredData.filter(report => report.centreCode === this.selectedCenterName);
    }

    if (this.selectedSubmitType) {
      filteredData = filteredData.filter(report =>
        report.submitType && report.submitType.toLowerCase() === this.selectedSubmitType.toLowerCase()
      );
    }

    if (this.reportType) {
      filteredData = filteredData.filter(report => report.reportType === this.reportType);
    }

    if (this.startDate && this.endDate) {
      const start = this.startDate.getTime();
      const end = this.endDate.getTime();
      filteredData = filteredData.filter(report => {
        const reportFrom = report.from.seconds * 1000;
        const reportTo = report.to.seconds * 1000;
        return reportFrom >= start && reportTo <= end;
      });
    }

    this.filteredDataSource.data = filteredData; // ← only update filtered, NOT original
    this.filteredDataSource.paginator = this.paginator;
  }


  clearAll(): void {
    this.SelectedCenters = null;
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedSubmitType = null;
    this.reportType = '';
    this.selectedCenterName = null;
    this.filteredDataSource.data = [...this.originalData]; // ← restore from original
    this.filteredDataSource.paginator = this.paginator;
  }
  applyFilter(event: Event) {
    console.log(event.target)
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredDataSource.filter = filterValue.trim().toLowerCase();
  }


  addReport() {
    this.mRouter.navigateByUrl('home/reports/impact-report');
  }

  ViewReport(id: string) {
    this.mRouter.navigate(['home/reports/impact-report', id]);

  }

  ViewReportImpact(id: string) {
    this.mRouter.navigate(['home/reports/view-impact-report', id]);
    let activity = {
      date: new Date().getTime(),
      section: 'Group Education',
      action: 'View',
      description: `View Education Impact Report by user`,
      currentIp: localStorage.getItem('currentip')!
    }
    this.mLogService.addLog(activity)
  }
  viewRepoerCard(){

  }



  downloadExcel() {
    if (!this.filteredDataSource || !this.filteredDataSource.data || this.filteredDataSource.data.length === 0) {
      this.mSnackbar.open('No data available to download', '', {
        duration: 2000
      });
      return;
    }

    const exportData = this.filteredDataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Centre': item.centreCode || '',
      'Total Sessions': item.totalSessions ?? '',
      'From': item.from?.seconds
        ? new Date(item.from.seconds * 1000).toLocaleDateString()
        : '',
      'To': item.to?.seconds
        ? new Date(item.to.seconds * 1000).toLocaleDateString()
        : '',
      'Created Date': item.createdAt?.seconds
        ? new Date(item.createdAt.seconds * 1000).toLocaleString()
        : '',
      'Submit Type': item.submitType ? item.submitType.toUpperCase() : '',
      'Report Type': item.reportType || 'NA'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Education Impact Report');

    XLSX.writeFile(workbook, 'Education_Impact_Report.xlsx');

    //  Activity Log
    const activity = {
      date: new Date().getTime(),
      section: 'Group Education',
      action: 'Download',
      description: 'Education Impact Report downloaded as Excel',
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.mSnackbar.open('Excel downloaded successfully', '', {
      duration: 2000
    });
  }


  @needConfirmation()
  deleteReport(id: string) {
    this.mFirestore.collection(this.env.educationImpactReport).doc(id).delete().then(() => {
      this.mSnackbar.open('Deleted', '', {
        panelClass: 'success-snackbar',
        duration: 3000
      });
      let activity = {
        date: new Date().getTime(),
        section: 'Group Education',
        action: 'Delete',
        description: `Delete Education Impact Report by user`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
